/**
 * Tab Navigation System - Configuration
 *
 * Default configuration for the tab-based navigation system.
 * These values can be overridden by user preferences stored in localStorage.
 */

import type { TabsConfig } from '@/context/TabsContext/types';

export const DEFAULT_TAB_CONFIG: TabsConfig = {
  // Behavior
  maxTabs: 10,
  defaultBehavior: 'reuse', // Sidebar clicks reuse existing tab or focus if open
  ctrlClickNewTab: true,
  middleClickNewTab: true,

  // Persistence
  persistPinnedTabs: true,
  persistRecentTabs: true,
  maxRestoredTabs: 10,

  // Pinned tabs
  pinnedTabMaxWidth: 120,
  defaultPinnedRoutes: ['/dashboard'],

  // UX
  showCloseOnHover: true,
  confirmCloseMultiple: true,
  enableDragReorder: true,
  enableKeyboardShortcuts: true,

  // Overflow
  overflowBehavior: 'dropdown',

  // Excluded from tabs (always full page)
  excludeRoutes: ['/login', '/404'],

  // Back button behavior
  onHistoryExhaust: 'nothing',

  // Undo support
  maxRecentlyClosed: 5,

  // Content caching
  enableContentCaching: true,
  maxCachedTabs: 5,
};

export const STORAGE_KEYS = {
  TABS_STATE: 'utx-ops-preferences-v1',
  /**
   * @deprecated Retired filename; merged into {@link STORAGE_KEYS.TABS_STATE} on first
   * load, then removed from localStorage.
   */
  LEGACY_TABS_STATE: 'utx-ops-tabs-v1',
  TABS_SETTINGS: 'utx-ops-tab-settings-v1',
} as const;

export const TABS_SCHEMA_VERSION = 1;
